import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconPermContactCalendar.tsx
const OutlinedFilledPermContactCalendar = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-204q58-53 131-82t160-29q87 0 159.5 28T771-206v-545H189v547Zm291-175q-59 0-100.5-41.5T338-521q0-59 41.5-100T480-662q59 0 100.5 41T622-521q0 59-41.5 100.5T480-379ZM189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-60h82v60h306v-60h82v60h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Z" })
});
const OutlinedPermContactCalendar = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M479.5-244Q414-244 354-222.5T240-155v6h480q-50-45-112.5-70t-128-25ZM189-204q58-53 131-82t160-29q87 0 159.5 28T771-206v-545H189v547Zm291-175q-59 0-100.5-41.5T338-521q0-59 41.5-100T480-662q59 0 100.5 41T622-521q0 59-41.5 100.5T480-379Zm.47-71q28.53 0 49.03-21.18 20.5-21.17 20.5-50 0-28.82-20.97-49.32t-49.5-20.5q-28.53 0-49.03 20.97t-20.5 49.5Q410-492 430.97-471t49.5 21ZM189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-60h82v60h306v-60h82v60h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm291-466Zm0 372h240-480 240Z" })
});
const RoundedFilledPermContactCalendar = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-204q58-53 131-82t160-29q87 0 159.5 28T771-206v-545H189v547Zm291-175q-59 0-100.5-41.5T338-521q0-59 41.5-100T480-662q59 0 100.5 41T622-521q0 59-41.5 100.5T480-379ZM189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.83 0 28.82 12.12Q327-881.75 327-865v19h306v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.84 0 28.82 12.12Q715-881.75 715-865v19h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Z" })
});
const RoundedPermContactCalendar = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M479.5-244Q414-244 354-222.5T240-155v6h480q-50-45-112.5-70t-128-25ZM189-204q58-53 131-82t160-29q87 0 159.5 28T771-206v-545H189v547Zm291-175q-59 0-100.5-41.5T338-521q0-59 41.5-100T480-662q59 0 100.5 41T622-521q0 59-41.5 100.5T480-379Zm.47-71q28.53 0 49.03-21.18 20.5-21.17 20.5-50 0-28.82-20.97-49.32t-49.5-20.5q-28.53 0-49.03 20.97t-20.5 49.5Q410-492 430.97-471t49.5 21ZM189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.83 0 28.82 12.12Q327-881.75 327-865v19h306v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.84 0 28.82 12.12Q715-881.75 715-865v19h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm291-466Zm0 372h240-480 240Z" })
});
const SharpFilledPermContactCalendar = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-204q58-53 131-82t160-29q87 0 159.5 28T771-206v-545H189v547Zm291-175q-59 0-100.5-41.5T338-521q0-59 41.5-100T480-662q59 0 100.5 41T622-521q0 59-41.5 100.5T480-379ZM95-55v-791h150.2v-60H327v60h306v-60h82.2v60H866v791H95Z" })
});
const SharpPermContactCalendar = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M479.5-244Q414-244 354-222.5T240-155v6h480q-50-45-112.5-70t-128-25ZM189-204q58-53 131-82t160-29q87 0 159.5 28T771-206v-545H189v547Zm291-175q-59 0-100.5-41.5T338-521q0-59 41.5-100T480-662q59 0 100.5 41T622-521q0 59-41.5 100.5T480-379Zm.47-71q28.53 0 49.03-21.18 20.5-21.17 20.5-50 0-28.82-20.97-49.32t-49.5-20.5q-28.53 0-49.03 20.97t-20.5 49.5Q410-492 430.97-471t49.5 21ZM95-55v-791h150.2v-60H327v60h306v-60h82.2v60H866v791H95Zm385-466Zm0 372h240-480 240Z" })
});
const componentMap = {
	outlined: OutlinedPermContactCalendar,
	"outlined-fill": OutlinedFilledPermContactCalendar,
	rounded: RoundedPermContactCalendar,
	"rounded-fill": RoundedFilledPermContactCalendar,
	sharp: SharpPermContactCalendar,
	"sharp-fill": SharpFilledPermContactCalendar
};
const IconPermContactCalendar = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconPermContactCalendar };